/**
 * Le note dei contenuti possono contenere marcatori interni scritti dal backend
 * quando il testo nasce dall'AI ("[Generato con AI Copywriter Assistant]",
 * "[Import AI] ..."). Sono informazioni di servizio nostre: al cliente non
 * devono mai comparire.
 */
export const cleanNote = (note?: string | null): string | undefined => {
  if (!note) return undefined;
  const cleaned = note
    .replace(/\[[^\]]*\bAI\b[^\]]*\]/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
  return cleaned || undefined;
};
